export default "__VITE_ASSET__C7d_BwE0__"